var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ReportingCard',{attrs:{"title":"Visits Per Hour","info-text":"An average of the most popular visit times by day of the week during the selected time span."}},[_c('HeatmapChart',{attrs:{"series":_vm.series,"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }